import { jsPDF } from 'jspdf';
import axiosInstance from '../../../../axiosInstance';
import { message } from 'antd';

// Fetching Shop Details
const fetchShopDetails = async () => {
    try {
        const response = await axiosInstance.get('/shop-details');
        if (response.status === 200) {
            return response.data.shop;
        } else {
            throw new Error('Error fetching shop details');
        }
    } catch (error) {
        console.log('Error:', error);
        return null;
    }
};

// Function to Export Products to PDF
// Function to Export Products to PDF
const exportToPDF = async (products) => {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

    // Fetch Shop Details
    const shop = await fetchShopDetails();
    if (!shop) {
        console.error('Shop details could not be fetched');
        message.error('Failed to fetch shop details');
        return;
    }

    const tableColumn = ["Name", "Buying Price", "Selling Price", "Quantity", "Category", "Barcode", "Status"];
    const tableRows = [];

    // Prepare table rows from products
    products.forEach(product => {
        const productData = [
            String(product.name),
            String(product.buying_price),
            String(product.selling_price),
            String(product.total_quantity || 0),
            String(product.category?.name || ''),
            String(product.barcode || ''),
            String(product.status?.status || '')
        ];
        tableRows.push(productData);
    });

    // Shop Header
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text(shop.name, 105, 10, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Phone: ${shop.phone || 'N/A'}`, 105, 15, { align: 'center' });
    doc.line(10, 20, 200, 20);

    // Product List Title
    doc.setFontSize(12);
    doc.text("Product List", 105, 30, { align: 'center' });

    // Table Setup
    const startX = 10;
    const startY = 40;
    const rowHeight = 8;
    const colWidth = 28;
    const pageHeight = doc.internal.pageSize.height;
    const marginBottom = 20;

    let currentY = startY;

    // Draw Table Header
    doc.setFontSize(10);
    tableColumn.forEach((col, index) => {
        const xPosition = startX + index * colWidth;
        if (index === 1 || index === 2) {
            const textXPosition = xPosition + colWidth - 3; // Right-align text
            doc.text(String(col), textXPosition, currentY, { align: 'right' });
        } else {
            doc.text(String(col), xPosition + 3, currentY);
        }
    });

    currentY += rowHeight;

    // Draw Rows with Pagination
    doc.setFontSize(9);
    tableRows.forEach((row, rowIndex) => {
        let maxRowHeight = 0;

        row.forEach((cell, colIndex) => {
            const xPosition = startX + colIndex * colWidth;
            const lines = doc.splitTextToSize(String(cell), colWidth - 6);
            const cellHeight = lines.length * 4;

            lines.forEach((line, lineIndex) => {
                const lineYPosition = currentY + lineIndex * 4;
                const textXPosition = colIndex === 1 || colIndex === 2
                    ? xPosition + colWidth - 3 // Right-align for specific columns
                    : xPosition + 3; // Default alignment
                doc.text(line, textXPosition, lineYPosition, { align: colIndex === 1 || colIndex === 2 ? 'right' : 'left' });
            });

            maxRowHeight = Math.max(maxRowHeight, cellHeight);
        });

        currentY += maxRowHeight;

        // Add a new page if the current row exceeds the page height
        if (currentY + rowHeight + marginBottom > pageHeight) {
            doc.addPage();
            currentY = startY;

            // Redraw Table Header on the new page
            tableColumn.forEach((col, index) => {
                const xPosition = startX + index * colWidth;
                if (index === 1 || index === 2) {
                    const textXPosition = xPosition + colWidth - 3; // Right-align text
                    doc.text(String(col), textXPosition, currentY, { align: 'right' });
                } else {
                    doc.text(String(col), xPosition + 3, currentY);
                }
            });

            currentY += rowHeight;
        }
    });

    // Save the PDF
    doc.save("product_list.pdf");

    // Success Message
    message.success('PDF exported successfully!');
};


export default exportToPDF;
